/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 三方订单
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { BaseModel, BasesController } from '../bases';
@BindAll()
export class ThirdRefundOrdersController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: false,
      details: EnumAPI.third_refund_orders_details, // 根据状态调用的接口不同
      pagination: EnumAPI.third_refund_orders_list,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: { valueGetter: this.paginationValueGetter },
      },
    });
  }

  Model = new BaseModel({ type: 'object', storageKey: 'order_status' });

  /**
   * 订单全部状态
   */
  @computed
  get OrderStatus(): Array<any> {
    // return this.Model.get('OrderStatus', [])
    return [
      { label: '正向订单', name: '正向订单', value: '0' },
      { label: '退货订单', name: '退货订单', value: '1' },
    ];

    return lodash.get(this.Model.value, 'OrderStatus', []);
  }

  /**
   * 物流信息
   */
  @computed
  get logisticsList(): Array<any> {
    return lodash.get(this.Model.value, 'logisticsList', []);
  }

  /**
   * 转换列表数据
   * @param response
   * @returns
   */
  paginationValueGetter(response) {
    let list = lodash.get(response, 'list', []);

    // // // 重组数据
    const dataSource = lodash.map(list, (val, key) => {
      const actionList = [
        {
          operationKey: 'viewInfoButton',
          operationRemark: '查看详情',
          operationValue: 1,
        },
      ];
      return {
        ...val,
        actionList,
      };
    });

    return {
      total: lodash.get(response, 'count'),
      dataSource,
    };
  }

  clearLogisticsList() {
    this.Model.merge({ logisticsList: [] });
  }
}
